import { Box, ListItem, ListItemText, SvgIcon, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import CertificateIcon from 'assets/icons/file-certificate.svg';
import PDFIcon from 'assets/icons/file-pdf.svg';
import AccessTimeIcon from 'assets/icons/invite.svg';
import EmployeeAvatar from 'components/@home/EmployeeAvatar';
import CheckIcon from 'mdi-react/CheckIcon';
import moment from 'moment';
import { bool, func, object } from 'prop-types';
import React, { memo } from 'react';
import { I18n } from 'utils/i18n';
import channelShape from 'shapes/channel';
import employeeShape from 'shapes/employee';
import connector from './connector';
import SendButton from './SendButton';

const AcknowledgeListItem = ({ employee, onSend, selected, actions, message, channel }) => {
  const ackEntry = message.acknowledges?.find(
    a => a.user?.toString?.() === String(employee.user_id || employee.user?._id),
  );

  const openModal = () => {
    actions.acknowledgmentReadModal.open(message, channel, employee, false);
  };

  const openModalLog = () => {
    actions.acknowledgmentReadModal.open(message, channel, employee, true);
  };

  return (
    <ListItem selected={selected}>
      <Box sx={{ pr: '15px' }}>
        {employee.confirmedAt ? (
          <Box sx={{ color: 'primary.main', display: 'inline-flex' }}>
            <CheckIcon />
          </Box>
        ) : (
          <Box sx={{ color: 'error.main', width: 18, height: 18, display: 'inline-flex' }}>
            <AccessTimeIcon />
          </Box>
        )}
      </Box>
      <Box sx={{ mr: '15px' }}>
        <EmployeeAvatar
          large
          employee={employee}
          status={employee.isAcceptTerms ? 'active' : 'pending'}
        />
      </Box>
      <ListItemText
        sx={{
          borderBottom: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
        secondaryTypographyProps={{ sx: { fontSize: 14 } }}
        primary={
          <Typography component="span" color={employee.isAcceptTerms ? 'default' : 'secondary'}>
            {[employee.firstName, employee.surName].filter(v => v).join(' ')}
          </Typography>
        }
        secondary={`${employee.jobTitle}, ${employee.department}`}
      />

      {employee.confirmedAt ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {(message.digitalSignature || ackEntry?.logUrl) && (
            <Button title={I18n.t('AnalyticsDrawer.Certificate')} onClick={openModalLog}>
              <SvgIcon sx={{ fontSize: 22 }}>
                <CertificateIcon />
              </SvgIcon>
            </Button>
          )}
          <Button title={I18n.t('AnalyticsDrawer.Open document')} onClick={openModal}>
            <SvgIcon sx={{ fontSize: 22 }}>
              <PDFIcon />
            </SvgIcon>
          </Button>
          <ListItemText
            sx={{
              textAlign: 'right',
              justifySelf: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              borderBottom: 0,
              width: 100,
            }}
            primaryTypographyProps={{ sx: { fontSize: 15 } }}
            primary={moment.unix(employee.confirmedAt).format('L')}
            secondary={moment.unix(employee.confirmedAt).format('LTS')}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            minHeight: 75,
          }}
        >
          <SendButton onSend={onSend} />
          <Typography sx={{ width: 100, textAlign: 'right' }} color="secondary">
            {I18n.t('AnalyticsDrawer.Pending')}
          </Typography>
        </Box>
      )}
    </ListItem>
  );
};

AcknowledgeListItem.propTypes = {
  actions: object.isRequired,
  channel: channelShape.isRequired,
  employee: employeeShape.isRequired,
  message: object.isRequired,
  onSend: func.isRequired,
  selected: bool.isRequired,
};

export default connector(memo(AcknowledgeListItem));
